import { applyFractionDigitsPrice } from "@/utils/amount"

/**
 * Convert price from cents to euros / dollars etc.
 *
 * @param {number|string} price
 * @returns {number}
 */
export function convertPriceFromCents(price) {
  return price / 100
}

/**
 * Get price formatted as currency (given in cents)
 *
 * @param {number|string} price
 * @param {string} currency
 * @param {string} locale
 * @returns {string|null}
 */
export function getPriceFormatted(price, currency = "EUR", locale = "de-DE") {
  if (typeof price !== "string" && typeof price !== "number") return price
  return convertPriceFromCents(price).toLocaleString(locale, {
    style: "currency",
    currency: currency,
  })
}

/**
 * Get price formatted as currency (given in euros / dollars etc.)
 *
 * @param {number|string} price
 * @param {string} currency
 * @param {string} locale
 * @returns {string|null}
 */
export function getFormattedInCurrency(price, currency = "EUR", locale = "de-DE") {
  if (typeof price !== "string" && typeof price !== "number") return price
  return price.toLocaleString(locale, {
    style: "currency",
    currency: currency,
  })
}

/**
 * Formats the given price based on the provided options
 *
 * @param {object} [price] - The price object to be formatted
 * @param {boolean} [sellableInDecimals] - Indicates whether the price is sellable in decimals
 * @param {string} [locale] - The locale to be used for formatting the price
 * @returns {string|null}
 */
export function getFormattedPriceWithDecimals(price, sellableInDecimals = false, locale = "de-DE", amount = 1) {
  if (!price) return null

  const priceToUse = (price?.preciseAmount || price?.centAmount) * amount

  const priceAmount = sellableInDecimals ? priceToUse * 1000 : priceToUse

  if (!priceAmount) return null

  const formattedEuroPrice = applyFractionDigitsPrice({
    fractionDigits: price?.fractionDigits,
    price: priceAmount,
  })

  return getFormattedInCurrency(formattedEuroPrice, price?.currencyCode, locale)
}
